import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface GroupTagProps {
  disabled?: boolean
  index: number
  onRemove?: (index: number) => void
  tag: { name: string; id: string; usersCount?: number }
  [props: string]: any
}

const GroupTag = ({ disabled, index, onRemove, tag }: GroupTagProps) => {
  return (
    <span
      className="inline-flex flex-row gap-2 p-2 text-gray-800 bg-gray-100 rounded-2xl cursor-default"
      key={tag.name}
    >
      <span>{tag.name}</span>
      <span>{`(${tag.usersCount})`}</span>
      {!disabled && (
        <button
          className="m-auto px-1 text-gray-400 hover:text-gray-500 focus:text-white hover:bg-gray-200 focus:bg-gray-500 rounded-xl focus:outline-none"
          onClick={() => onRemove(index)}
          type="button"
        >
          <FontAwesomeIcon className="w-4 h-4" icon={faTimes} />
        </button>
      )}
    </span>
  )
}

export default GroupTag
